import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { useSakusasVideoAdd } from "hooks/sakusas/video/useSakusasVideoAdd";
import { QUERY_KEYS } from "constant/react_query";
import VideoForm from "components/common/video/VideoForm/VideoForm";
import { useNavigate } from "react-router-dom";
import { videoFormDefaultValuesGet } from "common/video/video_form_common";

const VideoNew = () => {
  const { handleSubmit, reset, control, setValue } = useForm({
    defaultValues: videoFormDefaultValuesGet(),
  });
  const navigate = useNavigate();
  const { videoAddMutate } = useSakusasVideoAdd({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_VIDEO_SEARCH],
    successHandle: (id: any) => {
      console.log("add success", id);
      navigate(`/video/${id}`);
    },
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    const { datum, title, fileName } = data;

    console.log("datum", datum);
    const res = videoAddMutate({ datum, title, fileName });
    toast.success("New video added");
  };

  return (
    <>
      <div>Video Add</div>
      <DivVideo>
        <VideoForm
          control={control}
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          reset={reset}
          setValue={setValue}
        />
      </DivVideo>
    </>
  );
};

const DivVideo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 2rem;
  row-gap: 2rem;
  margin-top: 2rem;
`;

export default VideoNew;
